const hexToRgb = (hex: string) => {
  const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!m) return { r: 0, g: 0, b: 0 };
  return {
    r: parseInt(m[1], 16),
    g: parseInt(m[2], 16),
    b: parseInt(m[3], 16),
  };
};
const rgbToHex = (r: number, g: number, b: number) => {
  const toHex = (n: number) => n.toString(16).padStart(2, "0");
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};
const lerp = (a: number, b: number, t: number) => Math.round(a + (b - a) * t);
const lerpColor = (c1: string, c2: string, t: number) => {
  const a = hexToRgb(c1);
  const b = hexToRgb(c2);
  return rgbToHex(lerp(a.r, b.r, t), lerp(a.g, b.g, t), lerp(a.b, b.b, t));
};

export const TOP_BG = "#16c784";
export const BOT_BG = "#3a455f";
export const TOP_BORDER = "#27d29b";
export const BOT_BORDER = "#2c3555";

const getIntensity = (index: number, total: number) =>
  total <= 1 ? 1 : 1 - index / (total - 1);
export const getBadgeColors = (total: number, index: number) => {
  const t = getIntensity(index, total);
  return {
    bg: lerpColor(BOT_BG, TOP_BG, t),
    border: lerpColor(BOT_BORDER, TOP_BORDER, t),
  } as const;
};
